import {useCallback, useState} from 'react';
import {jobResume} from '../../api/callable/jobs';

export default function useResumeJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const resumeJob = useCallback(async (id: string) => {
    setLoading(true);
    setError(undefined);
    try {
      return await jobResume({id});
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {resumeJob, loading, error};
}
